import React from "react";

interface PageHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ icon, title, subtitle, action, children }) => {
  return (
    <div className="relative bg-gradient-to-br from-[#e0f7fa] via-[#f8fafc] to-[#e3fcec] rounded-2xl shadow-xl p-2 mb-6 flex flex-col gap-2 overflow-hidden border-0">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        {/* Left: Icon, Title, Subtitle */}
        <div className="flex items-center gap-2">
          <div className="flex items-center justify-center bg-[#0f8f8c] bg-gradient-to-br from-[#0f8f8c] to-[#4fd1c5] rounded-full h-7 w-7 shadow-lg">
            {icon}
          </div>
          <div>
            <h1 className="text-lg font-extrabold font-title text-primary mb-0.5 tracking-tight leading-tight">{title}</h1>
            <p className="text-muted-foreground font-serif text-xs leading-tight">{subtitle}</p>
          </div>
        </div>
        {/* Right: Action Button */}
        {action && (
          <div className="flex justify-end items-center mt-2 md:mt-0">
            {action}
          </div>
        )}
      </div>
      {/* Extra Content (e.g., stats row) */}
      {children && (
        <div className="w-full flex flex-col items-center">
          {children}
        </div>
      )}
    </div>
  );
}; 